<template>
  <div class="pop-up-message"
       :style="{ fontFamily: colors.font }"
  >
    <div class="pop-up-message--content"
         :class="{ text: message.type === 'text'}">
      <TextMessage v-if="message.type === 'text'"
                   :message="message"
                   :messageColors="messageStyles()"
                   :messageStyling="true"
                   @click.native="$emit('openChat')"
                   @remove="$emit('remove')"
      >
        <template v-slot:default="scopedProps">
          <slot name="text-message-body" :message="scopedProps.message" :messageText="scopedProps.messageText" :messageColors="scopedProps.messageColors" :me="scopedProps.me">
          </slot>
        </template>
        <template v-slot:text-message-toolbox="scopedProps">
          <slot name="text-message-toolbox" :message="scopedProps.message" :me="scopedProps.me">
          </slot>
        </template>
      </TextMessage>
      <ImageMessage v-else-if="message.type === 'image'" :data="message.data" />
      <CarouselMessage v-else-if="isCarouselMessage"
                       :data="message.data"
                       :messageColors="carouselMessageColors"
                       @buttonPressed="triggerButtonPressed"
      />
      <StructureMessage v-else-if="message.type === 'structure'"
                        class="pop-up-message-bubble"
                        :data="message.data"
                        :messageColors="structureMessageStyles()"
                        @buttonPressed="triggerButtonPressed" />
      <div class="pop-up-message--close-button" @click="$emit('close')">
        <icon-cross-small />
      </div>
    </div>

    <Suggestions v-if="message.suggestions"
                 :suggestions="message.suggestions"
                 v-on:sendSuggestion="triggerQuickReplyPressed"
                 :colors="colors"
                 justifyContent="end" />

  </div>
</template>

<script>
import TextMessage from './messages/TextMessage.vue'
import StructureMessage from './messages/StructureMessage.vue'
import ImageMessage from './messages/ImageMessage.vue'
import Suggestions from './Suggestions.vue'
import IconCrossSmall from './icons/icons/IconCrossSmall.vue'
import CarouselMessage from '@/components/chat/messages/CarouselMessage.vue'

export default {
  components: {
    CarouselMessage,
    TextMessage,
    StructureMessage,
    ImageMessage,
    Suggestions,
    IconCrossSmall
  },
  props: {
    message: {
      type: [Object, Array],
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    onButtonPressed: {
      type: Function,
      required: true
    }
  },

  computed: {
    isCarouselMessage () {
      return this.message.type === 'structure' && Array.isArray(this.message.data)
    },

    carouselMessageColors () {
      return {
        '--button-text': this.colors.sentMessage.carouselButton.text,
        '--button-text-hover': this.colors.sentMessage.carouselButton.textHover,
        '--button-bg-hover': this.colors.sentMessage.carouselButton.bgHover
      }
    }
  },

  methods: {
    messageStyles (isStruct = false) {
      if (isStruct) {
        return {
          background: this.colors.sentMessage.button.bg,
          color: this.colors.sentMessage.text,
          fontSize: this.colors.messageBubble.fontSize,
          fontWeight: this.colors.messageBubble.fontWeight,
          '--button-text': this.colors.sentMessage.button.text,
          '--button-text-hover': this.colors.sentMessage.button.textHover,
          '--button-bg-hover': this.colors.sentMessage.button.bgHover,
          '--button-radius': this.colors.sentMessage.button.radius || '6px'
        }
      }

      return {
        backgroundColor: '#FFF',
        borderRadius: '16px',
        color: '#000',
        fontSize: this.colors.messageBubble.fontSize,
        fontWeight: this.colors.messageBubble.fontWeight,
        lineHeight: this.colors.messageBubble.lineHeight,
        padding: '14px 33px 14px 14px'
      }
    },
    structureMessageStyles () {
      return {
        sent: this.messageStyles(true),
        received: {
          backgroundColor: '#FFF',
          borderRadius: '16px',
          color: '#000',
          fontSize: this.colors.messageBubble.fontSize,
          fontWeight: this.colors.messageBubble.fontWeight,
          lineHeight: this.colors.messageBubble.lineHeight,
          padding: '14px 14px 14px 14px'
        }
      }
    },
    triggerButtonPressed (button) {
      this.onButtonPressed({
        type: 'button',
        data: button
      })
    },
    triggerQuickReplyPressed (quickReply) {
      this.onButtonPressed({
        type: 'quickReply',
        data: quickReply
      })
    }
  }
}
</script>
